import { createFileRoute } from "@tanstack/react-router";
import { ConfirmLinkPage } from "@/features/portalsignin/ConfirmLinkPage";

/** X13-0811a: the confirm page an emailed approval returns to after the client signs in. */
export const Route = createFileRoute("/n/$token")({ component: Page });

function Page() {
  const { token } = Route.useParams();
  return <ConfirmLinkPage token={token} />;
}
